import React from 'react';
import Storage from "../utils/Storage";
import {Navigate} from 'react-router-dom'

const WithAuthRoutes = (WrappedComponent) => {
    return (props) => {
        return (
            <div>
                {
                    Storage.token ? <Navigate to={"/profile"}/> :
                        <WrappedComponent {...props}/>
                }
            </div>
        );
    }

};

export default WithAuthRoutes;
